module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAICAYAAADJEc7MAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABuSURBVHgBlc87DoAgDAbg/k6OjN7A0dEreAvPxuhRvIkjo1ttTTWIxtAm5VH6BQAzT0Q0ki/WRoaB/NErjJK7A2nvAl3JczuZZsm2AkUAG65KBb6RbpCf/OAHekHDwXCwUjr/lKFPWGCym1LZcwClYSTg5nCtUQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/assets/image/funds/arrow-drop-down.png
// module id = NbJS
// module chunks = 0